import { useQuery } from '@tanstack/react-query'

import { StorePersistKeys } from 'src/types'
import { TIME_IN_MS } from 'src/constants'

import { getActualCurrency1inch } from 'src/api/ActualCurrency1inch'

export const useGetActualCurrencyOneInch = () => {
  return useQuery({
    queryKey: [StorePersistKeys.CURRENCY],
    queryFn: getActualCurrency1inch,
    refetchInterval: TIME_IN_MS.HOUR * 4,
  })
}
